import React from 'react';

import { AnimacaoCarregando } from 'Component/Animacao';

interface Props {
    titulo?: string;
    subtitulo?: string;
}

const Carregando = ({ titulo, subtitulo }: Props): React.ReactElement =>
{
    return (
        <React.Fragment>
            <AnimacaoCarregando />
            { titulo && (
                <p className="mt-5 mb-0 fs-1 fw-light text-white text-center">
                    { titulo }
                </p>
            ) }
            { subtitulo && (
                <p className="lead text-muted text-center">
                    { subtitulo }
                </p>
            ) }
        </React.Fragment>
    );
}

export default Carregando;
